import React, { useCallback } from 'react'
import { useHistory } from 'react-router'
import { returnType } from '../../../../../OrderHistory/components/buttons/manageButtonType'
import { RmaDetailLRButtonContainer, ReturnLink } from './style/ButtonWmo.css'

const DetailButtonWmo = ({
  submitForm,
  orderDetails,
}) => {
  const { order_id: orderId } = { ...orderDetails }
  const history = useHistory()
  const cancelReturn = useCallback(() => {
    history.push(`/myaccount/orderdetails?orderId=${orderId}&returnType=${returnType.lifetime}`)
  }, [history, orderId])

  return (
    <RmaDetailLRButtonContainer>
      <p>
        Please note that once a return request has been submitted, it cannot be edited or cancelled. Please make sure that everything is entered correctly.
      </p>
     
      <button
        type="button"
        onClick={submitForm}
      >
        Submit Claim
      </button>

      <p>
        By clicking “Submit Claim”,
        I confirm that I have already purchased an identical part
        from CarParts.com to
        replace my original order.
      </p>
      <ReturnLink type="button" onClick={cancelReturn}>
        <span>Cancel Lifetime Replacement Claim</span>
      </ReturnLink>
    </RmaDetailLRButtonContainer>
  )
}

export default DetailButtonWmo
